import { useCallback } from 'react';
import dayjs from 'dayjs';
import { BarClick } from '@frontend/charts';
import { AppointmentAnalyticsV2TableFiltersState } from '../types';
import { useAppointmentAnalyticsV2ShallowStore } from './use-appointment-analytics-v2-store';

export const useBarClickRedirection = () => {
  const { applyFiltersAndSwitchToTableView } = useAppointmentAnalyticsV2ShallowStore(
    'applyFiltersAndSwitchToTableView'
  );

  return useCallback(
    (
      args: BarClick,
      groups: { name: string; rawName?: string }[],
      filtersToApply: Partial<AppointmentAnalyticsV2TableFiltersState>
    ) => {
      const clickedGroup = groups.find((g) => g.name === args.group);
      const dateStr = clickedGroup?.rawName;

      applyFiltersAndSwitchToTableView({
        ...filtersToApply,
        ...(dateStr
          ? {
              startDate: dayjs(dateStr).startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS'),
              endDate: dayjs(dateStr).endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS'),
            }
          : {}),
      });
    },
    [applyFiltersAndSwitchToTableView]
  );
};
